export const countrySelectStyles = {
    autocomplete: {
        width: {
        xs: '100%',
        sm: '300px',
        md: '404px',
        },
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        cursor: 'pointer',
        '&:hover': {
        backgroundColor: '#f0f0f0',
        },
    },
};
